import styled from 'styled-components';

export const StyledEventCountdownPage = styled.section`
    width: 100%;
    height: 100vh;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;

    @media only screen and (max-width: 768px) {
        height: auto;
        min-height: 100vh;
    }

    @media only screen and (max-width: 479px) {
        > p {
            font-size: 28px;
        }
    }
`;
